import React, {useEffect} from "react";
import {Divider, Grid, Paper, Typography, withStyles,} from "@material-ui/core";
import {mobileIcon, remoteIcon, workIcon, workVerifierIcon, workCheckIcon, workDiagnoseIcon, mobileCheckIcon, mobileDiagnoseIcon, mobileErasureLiteIcon, mobileVerifierIcon, moneyIcon} from "../../sc-accountManagement/PrepaidBalance/utils";
import {connect} from "react-redux";

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(0)
    },
    grid: {
        padding: theme.spacing(2)
    },
    heading2: {
        fontSize: '120%',
        paddingLeft: theme.spacing(1),
    },
    divider: {
        width: 'auto',
        height: '1px'
    },
    heading3: {
        fontSize: '115%',
        fontWeight: 'bold',
        paddingLeft: theme.spacing(1),
    },
    moneyIcon: {
        color: '#7485FF',
    },
    icon: {
        position: "relative",
        top: "5px"
    },
});

const IndividualLicenses = (props) => {
    const { classes, activeCustomer, user, onLoadUser, translations, Balances, IndividualLicensingEnabled } = props;

    useEffect(() => {
        const getUser = async () => {
            await onLoadUser({ UserID: user?.UserID, ActiveCustomerID: activeCustomer });
        }

        user && getUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const findItem = (value) => {
        return (Balances ?? []).find(el => el.Unit === value);
    };

    if (!IndividualLicensingEnabled) {
        return <Paper className={classes.root}>
            <Typography className={classes.heading2}>{translations["individual_licensing_is_disabled"] || 'Individual licensing is disabled'}</Typography>
        </Paper>
    }

    return (
        <Paper className={classes.root}>
            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workIcon}</span> {translations["work_erasure"] || 'Work Erasure'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work')? Math.floor(findItem('work')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workVerifierIcon}</span> {translations["work_erasure_verification"] || 'Work Erasure Verification'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work_verifier')? Math.floor(findItem('work_verifier')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workDiagnoseIcon}</span> {translations["work_diagnose"] || 'Work Diagnose'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work_diagnose')? Math.floor(findItem('work_diagnose')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{workCheckIcon}</span> {translations["work_check"] || 'Work Check'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('work_check')? Math.floor(findItem('work_check')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileIcon}</span> {translations["mobile_erasure"] || 'Mobile Erasure'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile')? Math.floor(findItem('mobile')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileErasureLiteIcon}</span> {translations["mobile_erasure_lite"] || 'Mobile Erasure Lite'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_erasure_lite')? Math.floor(findItem('mobile_erasure_lite')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileVerifierIcon}</span> {translations["mobile_erasure_verification"] || 'Mobile Erasure Verification'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_verifier')? Math.floor(findItem('mobile_verifier')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileDiagnoseIcon}</span> {translations["mobile_diagnose"] || 'Mobile Diagnose'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_diagnose')? Math.floor(findItem('mobile_diagnose')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{mobileCheckIcon}</span> {translations["mobile_check"] || 'Mobile Check'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('mobile_check')? Math.floor(findItem('mobile_check')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography variant='subtitle1' className={classes.heading2}><span className={classes.icon}>{remoteIcon}</span> {translations["remote"] || 'Remote'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('remote')? Math.floor(findItem('remote')?.Credits || 0.00) : 0}</Typography>
                </Grid>
            </Grid>

            <Divider orientation="vertical" flexItem className={classes.divider} />

            <Grid container direction="row" alignItems="center" justify={"center"} spacing={2} className={classes.grid}>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading2}><span className={classes.icon}>{moneyIcon}</span> {translations["money"] || 'Money'}</Typography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Typography className={classes.heading3}>{findItem('currency')?.Credits || '0.00'}{' $'}</Typography>
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        Balances: state?.user?.users?.loaded?.Balances || [],
        IndividualLicensingEnabled: !!(state?.user?.users?.loaded?.ActiveCustomer?.IndividualLicensingEnabled || false)
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(IndividualLicenses));
